<template>
  <v-container fluid class="pa-4">
    <h4 class="ml-4 mb-4">My Health Suite</h4>
    
    <v-row no-gutters>
      <!-- My Diary Section -->
      <v-col cols="6" class="pr-2">
        <div class="diary-section clickable-section" @click="navigateToHealthSuite">
          <h5 class="mb-2">My Diary</h5>
          
          <div class="diary-entry">
            <div class="entry-icon">
              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.11328 20V10.85C2.26328 10.6167 1.55078 10.15 0.975781 9.45C0.400781 8.75 0.113281 7.93333 0.113281 7V0H2.11328V7H3.11328V0H5.11328V7H6.11328V0H8.11328V7C8.11328 7.93333 7.82578 8.75 7.25078 9.45C6.67578 10.15 5.96328 10.6167 5.11328 10.85V20H3.11328ZM13.1133 20V12H10.1133V5C10.1133 3.61667 10.6008 2.4375 11.5758 1.4625C12.5508 0.4875 13.7299 0 15.1133 0V20H13.1133Z" :fill="buttonColor"/>
              </svg>
            </div>
            <div class="entry-content">
              <div class="entry-time">7:00 AM</div>
              <div class="entry-text">I ate 2 eggs...</div>
            </div>
          </div>
          
          <div class="diary-entry">
            <div class="entry-icon">
              <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.355469" width="30" height="30" rx="8" :fill="primaryColor"/>
                <rect x="0.355469" width="30" height="30" rx="8" fill="url(#paint0_linear_0_1)"/>
                <path d="M8.19828 22.8153C8.52928 22.8153 8.81891 22.6944 9.06716 22.4528C9.3154 22.2111 9.43953 21.9292 9.43953 21.6069C9.43953 21.2847 9.3154 21.0028 9.06716 20.7611C8.81891 20.5194 8.52928 20.3986 8.19828 20.3986C7.86728 20.3986 7.57766 20.5194 7.32941 20.7611C7.08116 21.0028 6.95703 21.2847 6.95703 21.6069C6.95703 21.9292 7.08116 22.2111 7.32941 22.4528C7.57766 22.6944 7.86728 22.8153 8.19828 22.8153ZM8.19828 16.2097C8.52928 16.2097 8.81891 16.0889 9.06716 15.8472C9.3154 15.6056 9.43953 15.3236 9.43953 15.0014C9.43953 14.6792 9.3154 14.3972 9.06716 14.1556C8.81891 13.9139 8.52928 13.7931 8.19828 13.7931C7.86728 13.7931 7.57766 13.9139 7.32941 14.1556C7.08116 14.3972 6.95703 14.6792 6.95703 15.0014C6.95703 15.3236 7.08116 15.6056 7.32941 15.8472C7.57766 16.0889 7.86728 16.2097 8.19828 16.2097ZM8.19828 9.60417C8.52928 9.60417 8.81891 9.48333 9.06716 9.24167C9.3154 9 9.43953 8.71806 9.43953 8.39583C9.43953 8.07361 9.3154 7.79167 9.06716 7.55C8.81891 7.30833 8.52928 7.1875 8.19828 7.1875C7.86728 7.1875 7.57766 7.30833 7.32941 7.55C7.08116 7.79167 6.95703 8.07361 6.95703 8.39583C6.95703 8.71806 7.08116 9 7.32941 9.24167C7.57766 9.48333 7.86728 9.60417 8.19828 9.60417ZM13.6598 22.8153H23.7553V20.3986H13.6598V22.8153ZM13.6598 16.2097H23.7553V13.7931H13.6598V16.2097ZM13.6598 9.60417H23.7553V7.1875H13.6598V9.60417Z" fill="white"/>
                <defs>
                  <linearGradient id="paint0_linear_0_1" x1="15.3555" y1="0" x2="15.3555" y2="30" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" stop-opacity="0.2"/>
                    <stop offset="1" stop-color="white" stop-opacity="0"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="entry-content">
              <div class="entry-time">9:00 AM</div>
              <div class="entry-text">Morning Yoga...</div>
            </div>
          </div>
        </div>
      </v-col>
      
      <!-- My Tracker Section -->
      <v-col cols="6" class="pl-2">
        <div class="tracker-section clickable-section" @click="navigateToHealthTracker">
          <h5 class="mb-2">My Tracker</h5>
          
          <div class="tracker-header">
            <span class="tracker-label">Sleep</span>
            <div class="tracker-nav">
            </div>
          </div>
          
          <div class="sleep-chart">
            <svg viewBox="0 0 200 80" class="chart-svg">
              <path 
                d="M10,60 Q30,40 50,45 T90,35 Q110,25 130,30 T170,40 Q185,35 190,30" 
                :stroke="secondaryColor" 
                stroke-width="3" 
                fill="none"
              />
            </svg>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSettingsStore } from '@/api/store/settings';

const router = useRouter();
const settingsStore = useSettingsStore();

const buttonColor = computed(() => settingsStore.settings.buttonColor);
const primaryColor = computed(() => settingsStore.settings.primaryColor);
const secondaryColor = computed(() => settingsStore.settings.secondaryColor);

const navigateToHealthSuite = () => {
  router.push('/health-suite');
};

const navigateToHealthTracker = () => {
  router.push('/health-suite/tracker');
};
</script>

<style scoped>
.diary-section,
.tracker-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  height: 100%;
  transition: all 0.2s ease;
}

.clickable-section {
  cursor: pointer;
  user-select: none;
}

.clickable-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.clickable-section:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin-bottom: 16px;
  margin-top: 0;
}

.diary-entry {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.diary-entry:last-child {
  margin-bottom: 0;
}

.entry-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.entry-content {
  flex: 1;
}

.entry-time {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-bottom: 2px;
}

.entry-text {
  font-size: 14px;
  color: #666;
}

.tracker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tracker-label {
  font-size: 16px;
  color: #666;
}

.tracker-nav {
  display: flex;
  gap: 8px;
}

.tracker-nav .v-icon {
  color: #ccc;
  cursor: pointer;
}

.sleep-chart {
  height: 80px;
  width: 100%;
}

.chart-svg {
  width: 100%;
  height: 100%;
}
</style> 